import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Button, Label } from "semantic-ui-react";
import { useCopyToClipboard } from "../Hooks/useCopyToClipboard";
export default function CopyField({ val, altval, title, label, inline }) {
    const { copyToClipboard, copied } = useCopyToClipboard();
    const onCopy = (e) => {
        e.stopPropagation();
        copyToClipboard((e.shiftKey && altval) || val);
    };
    if (inline) {
        return (_jsxs("span", { className: "cursor-pointer whitespace-nowrap inline-flex", onClick: onCopy, title: title, children: [_jsx(Icon, { color: "grey", name: copied ? "check" : "clipboard" }), " ", label || val] }));
    }
    return (_jsxs(Button, { as: "div", labelPosition: "right", size: "tiny", style: { marginTop: ".5em" }, onClick: onCopy, title: title, children: [_jsx(Button, { icon: true, size: "tiny", children: _jsx(Icon, { name: copied ? "check" : "clipboard" }) }), _jsx(Label, { as: "a", basic: true, pointing: "left", children: label || val })] }));
}
